<app-scanner (scan)="scan.scanned($event, 'scan-result', true)"></app-scanner>
